@use "variables" as *;

.item {
  border-radius: 12px;
}

.container {
  width: 100%;
  display: flex;
}

.actionArea {
  display: flex;
  flex-grow: 1;
  height: 100%;
  padding: $spacing-s $spacing-l !important;
}

.positionContainer {
  width: fit-content !important;
}

.name {
  font-size: $fontSize-m;
  font-weight: bold;
  text-align: left;
  width: 100%;
}

.visibility {
  text-transform: uppercase;
  font-size: $fontSize-xxxs;
  font-weight: lighter;
  text-align: right;
  margin-left: $spacing-s;
}

.description {
  font-size: $fontSize-xs;
  font-weight: normal;
  white-space: pre-wrap;
  width: 100%;
  text-align: left;
  vertical-align: top;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.deleteButton {
  aspect-ratio: 1;
  border-radius: 0 !important;
  width: fit-content !important;
  height: 100%;
}

.trailingContainer {
  display: flex;
  align-items: center;
}

.dragIconContainer {
  width: 24px;
  display: flex;
}

.dragIcon {
  font-size: $fontSize-ml !important;
  align-self: center;
}
